<script setup lang="ts">
import { LazyModalSupportTicket } from "#components";
import { version } from "../../package.json";

const { trackEvent } = useGAnalytics();
const { openModal } = useModalManager();

const openSupportTicket = () => {
  trackEvent("footer_main_support");
  openModal({
    id: "modal-support-ticket",
    component: LazyModalSupportTicket,
  });
};

type FooterLink = {
  label?: string;
  labelKey?: string;
  test: string;
  event?: string;
  to?: string;
  external?: boolean;
  action?: () => void;
};

const links: FooterLink[] = [
  {
    labelKey: "main.appFooter.termsAndConditions",
    to: "/legal/terms-and-conditions",
    test: "link-legal-terms-and-conditions",
    event: "footer_main_terms",
  },
  {
    labelKey: "main.appFooter.privacyPolicy",
    to: "https://gfal.com/privacy-policy/",
    test: "link-legal-privacy-policy",
    event: "footer_main_privacy_policy",
    external: true,
  },
  {
    labelKey: "main.appFooter.cookiePolicy",
    to: "/legal/cookie-policy",
    test: "link-legal-cookie-policy",
    event: "footer_main_cookie_policy",
  },
  {
    labelKey: "main.appFooter.legalNotice",
    to: "https://gfal.com/legal-notice/",
    test: "link-legal-legal-notice",
    event: "footer_main_legal_notice",
    external: true,
  },
  {
    label: "Changelog",
    to: "/changelog",
    test: "link-changelog",
    event: "footer_main_changelog",
  },
  {
    labelKey: "main.appFooter.contactSupport",
    test: "link-support",
    action: openSupportTicket,
  },
];
</script>

<template>
  <footer
    class="relative w-screen border-t border-neutral-800 mb-8 lg:mb-0 mt-8 flex flex-col lg:flex-row justify-center lg:justify-between items-center px-6">
    <div class="py-5 flex flex-col gap-4">
      <div class="md:mt-0 flex-1">
        <p class="text-xs leading-5 text-neutral-400 text-center lg:text-left">
          {{
            $t("main.appFooter.copyrightNotice", {
              year: "2023" + " - " + new Date().getFullYear(),
              version: version.split("_")[0],
            })
          }}
        </p>
      </div>
      <nav aria-label="BreadCrumb">
        <ol role="list" class="flex">
          <li
            v-for="(link, index) in links"
            :key="link.test"
            class="flex items-center text-neutral-400 font-light">
            <button
              v-if="link.action"
              :data-test="link.test"
              type="button"
              class="text-xs hover:text-primary-500 text-center cursor-pointer"
              @click="link.action">
              <p style="text-transform: none">
                {{ link.labelKey ? $t(link.labelKey) : link.label }}
              </p>
            </button>
            <NuxtLinkLocale
              v-else
              :data-test="link.test"
              :to="link.to"
              :target="link.external ? '_blank' : '_self'"
              class="text-xs hover:text-primary-500 text-center cursor-pointer"
              @click="link.event && trackEvent(link.event)">
              <p>{{ link.labelKey ? $t(link.labelKey) : link.label }}</p>
            </NuxtLinkLocale>
            <span v-if="index !== links.length - 1" class="mx-4">|</span>
          </li>
        </ol>
      </nav>
    </div>
    <div
      class="lg:pr-24 w-full lg:w-auto flex flex-col gap-3 mt-6 lg:mt-0 items-center lg:items-end">
      <CommonLanguages />
    </div>
  </footer>
</template>
